import React from 'react';
import EntityPicker from './EntityPicker';
import { useZdsMenuHost } from '../hooks/useZdsMenuHost';

interface MultiEntityControllerProps {
  menuType?: string;
  isVisible?: boolean;
  navRootElement: Element | null;
}

const MultiEntityController = ({
  menuType,
  isVisible = true,
  navRootElement,
}: MultiEntityControllerProps) => {
  const menuElement = useZdsMenuHost({
    selector: 'z-multi-org-menu[entity="true"]',
    isVisible,
    navRootElement,
  });

  if (!isVisible || !menuElement) {
    return null;
  }

  return <EntityPicker menuElement={menuElement} menuType={menuType} />;
};

export default MultiEntityController;
